module.exports = "/images/Logo_quotazioni.png?d5b4f53af32759e057b0b0474ea2ce75";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Logo_quotazioni.png
// module id = RzlG
// module chunks = 1